<div class="modal-header">
    <h3 class="modal-title" id="modal-title" translate="DOCUMENT_FEEDBACK_HEADER"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="documentFeedbackForm">
        <div class="row mb-3">
            <strong class="p-2"> {{ 'DOCUMENT_FEEDBACK_BODY_TEXT' | translate }}</strong>
        </div>
        <div class="row mb-3">
            <label
                for="gid"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="DOCUMENT_FEEDBACK_FIELD_DESCRIPTION"
            ></label>
            <div class="col-sm-9">
                <pace-core-text-input
                    [(model)]="model.feedback_description"
                    id="feedback_description"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="section_number"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="DOCUMENT_FEEDBACK_FIELD_SECTION_NUMBER"
            ></label>
            <div class="col-sm-9">
                <pace-core-text-input
                    [(model)]="model.section_number"
                    id="section_number"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
        </div>

        <div class="row mb-3">
            <label
                for="form_Id"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="DOCUMENT_FEEDBACK_FIELD_FORM_ID"
            ></label>
            <div class="col-sm-9">
                <pace-core-text-input
                    [(model)]="model.form_id"
                    id="form_id"
                    [parentForm]="formChildren"
                ></pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3">
            <label
                for="category"
                class="col-sm-3 text-sm-end text-start text-nowrap col-form-label"
                translate="DOCUMENT_FEEDBACK_FIELD_CATEGORY"
            ></label>
            <div class="col-sm-9">
                <pace-core-radio-input
                    [(model)]="model.category"
                    id="category"
                    [parentForm]="formChildren"
                    [ariaLabel]="'DOCUMENT_FEEDBACK_FIELD_CATEGORY' | translate"
                ></pace-core-radio-input>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary"
        type="button"
        (click)="modalInstance.hide()"
        translate="DOCUMENT_FEEDBACK_CANCEL_BUTTON_TEXT"
    ></button>
    <button
        class="btn btn-primary"
        type="button"
        (click)="submitData()"
        translate="DOCUMENT_FEEDBACK_SUBMIT_BUTTON_TEXT"
        [disabled]="documentFeedbackForm.invalid"
    ></button>
</div>
